/**
 * airan-ntn — xApp Factory
 */

import { XAppBase } from './XAppBase.js';
import { HoPredictXApp } from './HoPredictXApp.js';
import { BeamHopXApp } from './BeamHopXApp.js';
import { SliceManagerXApp } from './SliceManagerXApp.js';
import { DopplerCompXApp } from './DopplerCompXApp.js';
import { TnNtnSteeringXApp } from './TnNtnSteeringXApp.js';
import { EnergyHarvestXApp } from './EnergyHarvestXApp.js';
import { InterferenceMgmtXApp } from './InterferenceMgmtXApp.js';
import { MultiConnXApp } from './MultiConnXApp.js';
import { PredictiveAllocXApp } from './PredictiveAllocXApp.js';
import { XAppType, SimConfig } from '../types.js';

export function createXApp(type: XAppType, enabled: boolean = true): XAppBase {
  switch (type) {
    case 'ho-predict': return new HoPredictXApp(enabled);
    case 'beam-hop': return new BeamHopXApp(enabled);
    case 'slice-manager': return new SliceManagerXApp(enabled);
    case 'doppler-comp': return new DopplerCompXApp(enabled);
    case 'tn-ntn-steering': return new TnNtnSteeringXApp(enabled);
    case 'energy-harvest': return new EnergyHarvestXApp(enabled);
    case 'interference-mgmt': return new InterferenceMgmtXApp(enabled);
    case 'multi-conn': return new MultiConnXApp(enabled);
    case 'predictive-alloc': return new PredictiveAllocXApp(enabled);
    default: throw new Error(`Unknown xApp type: ${type}`);
  }
}

export function createAllXApps(config: SimConfig): Map<XAppType, XAppBase> {
  const xApps = new Map<XAppType, XAppBase>();
  for (const type of config.enabledXApps) {
    xApps.set(type, createXApp(type, true));
  }
  return xApps;
}

// Re-export all xApp classes
export { XAppBase } from './XAppBase.js';
export { HoPredictXApp } from './HoPredictXApp.js';
export { BeamHopXApp } from './BeamHopXApp.js';
export { SliceManagerXApp } from './SliceManagerXApp.js';
export { DopplerCompXApp } from './DopplerCompXApp.js';
export { TnNtnSteeringXApp } from './TnNtnSteeringXApp.js';
export { EnergyHarvestXApp } from './EnergyHarvestXApp.js';
export { InterferenceMgmtXApp } from './InterferenceMgmtXApp.js';
export { MultiConnXApp } from './MultiConnXApp.js';
export { PredictiveAllocXApp } from './PredictiveAllocXApp.js';